import {
  ChangeDetectionStrategy,
  Component,
  input,
  TemplateRef,
  AfterContentInit,
  contentChildren,
  output,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import {
  NgbNav,
  NgbNavContent,
  NgbNavItem,
  NgbNavLinkButton,
  NgbNavOutlet,
} from '@ng-bootstrap/ng-bootstrap';
import { TabContentInterface, TranslocoFunction } from '../../types';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ui-tabs-content',
  imports: [
    NgbNav,
    NgbNavLinkButton,
    NgbNavContent,
    NgbNavOutlet,
    NgbNavItem,
    NgTemplateOutlet,
    TranslocoPipe,
  ],
  templateUrl: './tabs-content.component.html',
  styleUrl: './tabs-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsContentComponent implements AfterContentInit {
  tabs = input<TabContentInterface[]>([]);
  active = input<string>();
  withoutTranslate = input(false);
  t = input<TranslocoFunction>();
  tabContents = contentChildren<TemplateRef<TabContentInterface>>(TemplateRef);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openTab = output<any>();

  contentMap = new Map<string, TemplateRef<TabContentInterface>>();

  ngAfterContentInit() {
    this.tabs().forEach((tab, index) => {
      this.contentMap.set(tab.id, this.tabContents()[index]);
    });
  }

  tabOpen(id: string) {
    this.openTab.emit(id);
  }
}
